/** Nango integration unique_key for Google Drive (keep in sync with API nango-integrations.constants.ts). */
export const GOOGLE_DRIVE_NANGO_INTEGRATION_ID = "google-drive";

/** Nango integration unique_key for SharePoint (keep in sync with API nango-integrations.constants.ts). */
export const SHAREPOINT_NANGO_INTEGRATION_ID = "sharepoint-online-salt-test";

/** Keep in sync with API nango-integrations.constants.ts */
export const FIREFLIES_NANGO_INTEGRATION_ID = "fireflies";

/** Providers that support manual folder sync on linked external roots. */
export const EXTERNAL_FOLDER_SYNC_PROVIDERS = [
  "GOOGLE_DRIVE",
  "SHAREPOINT",
] as const;

export type SharePointConnectionConfig = {
  tenantId: string;
  tenant: string;
};
